/**
 * Program Page - Uses unified content page
 */
import React from "react";
import { ContentPage } from "../../components/content";

const ProgramPage = () => {
  return <ContentPage />;
};

export default ProgramPage;
